export default __webpack_public_path__ + "static/media/coinye.366ac21f.png";